import React from 'react';

import { Avatar, Link, Text } from '@change/ds-core-ui/next';

import type { DecisionMaker } from '../../../hooks/useDecisionMakers';
import { DecisionMakerResponse } from '../../DecisionMakerResponse';

export const Member: React.FC<DecisionMaker> = ({
	photoUrl,
	displayName,
	publiclyVisible,
	slug,
	id,
	title,
	signersText,
	response,
}) => {
	return (
		<div className="flex flex-col items-center md:flex-row md:items-start">
			<Avatar src={photoUrl || undefined} alt={displayName} size={48} className="mb-3 mr-3 flex-shrink-0" />
			<div className="flex flex-col items-center md:items-start">
				<div className="flex flex-col items-center md:flex-row">
					<div className="">
						{publiclyVisible ? (
							<Link
								bold
								data-qa="dm-link"
								href={`/decision-makers/${slug || id}?source_location=petition_details_gamma_legislative_bodies`}
								className="mr-2"
							>
								<Text variant="heading">{displayName}</Text>
							</Link>
						) : (
							<Text variant="heading" size="x-small" className="mr-2">
								{displayName}
							</Text>
						)}
					</div>

					<Text variant="body" className="text-muted mr-2 text-sm">
						{title}
					</Text>
				</div>
				<Text as="div" className="text-muted mb-2 text-sm">
					{signersText}
				</Text>
				<div>
					<DecisionMakerResponse response={response} />
				</div>
			</div>
		</div>
	);
};
